// extracted by mini-css-extract-plugin
export var container = "styles-module__container___g8tbZ";
export var content = "styles-module__content___ilG97";
export var contentAndImageContainer = "styles-module__contentAndImageContainer___w9kqE";
export var header = "styles-module__header___TFb7e";
export var image = "styles-module__image____HcW4";
export var imageOverlay = "styles-module__imageOverlay___lwpEM";
export var logoAnimation = "styles-module__logoAnimation___kyQZz";
export var outerContainer = "styles-module__outerContainer___S8gXY";
export var subText = "styles-module__subText___dMLHX";